<template>
  <v-app>
    <header>
      <v-app-bar
        app
        style="background-color: #fff"
      >
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-toolbar-title style="padding: 0 10px 0 0">
          <v-img
            src="@/assets/logo.svg"
            height="40"
            width="120"
            contain
          ></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tabs class="d-none d-md-flex custom-tabs top-tabs" :class="{ 'inactive-tabs': !isTopMenuActive }" slider-color="transparent">
          <v-tab to="/president_greeting" style="font-size: 0.8em"><b>代表ご挨拶</b></v-tab>
          <v-tab to="/staff_voice" style="font-size: 0.8em"><b>スタッフの声</b></v-tab>
          <v-tab to="/business" style="font-size: 0.8em"><b>事業内容</b></v-tab>
          <v-tab to="/company" style="font-size: 0.8em"><b>会社情報</b></v-tab>
          <v-tab to="/toiawase" style="font-size: 0.8em"><b>お問い合わせ</b></v-tab>
          <v-tab to="/accessmap" style="font-size: 0.8em"><b>アクセスマップ</b></v-tab>
        </v-tabs>
        <v-btn
            flat
            class="bg-blue ma-2 text-white d-none d-md-flex"
            to="/opt_search"
          ><v-icon size="small">mdi-magnify</v-icon>&nbsp;光パッチコード在庫検索</v-btn>
        <v-btn
          flat
          class="bg-blue ma-2 text-white"
          to="/search"
        >
          <v-icon size="small">mdi-magnify</v-icon>&nbsp;電子部品検索
        </v-btn>
        <template v-slot:extension>
        <v-tabs show-arrows grow class="custom-tabs bottom-tabs" :class="{ 'inactive-tabs': isTopMenuActive }" slider-color="transparent">
          <v-tab to="/"><b>ホーム</b></v-tab>
          <v-tab to="/news"><b>新着情報</b></v-tab>
          <v-tab to="/electronics"><b>電子部品</b></v-tab>
          <v-tab to="/electronics_focus" style="font-size: 0.6em"><b>注目の電子部品</b></v-tab>
          <v-tab to="/search" style="font-size: 0.6em"><b>部品在庫検索</b></v-tab>
          <v-tab to="/maker" style="font-size: 0.6em"><b>取引メーカー</b></v-tab>
          <v-tab to="/networking"><b>光通信関連部品</b></v-tab>
          <v-tab to="/opt_stock" style="font-size: 0.6em"><b>在庫一覧</b></v-tab>
          <v-tab to="/attenuator" style="font-size: 0.6em"><b>光アッテネーター</b></v-tab>
          <v-tab to="/opt_search" style="font-size: 0.6em"><b>光パッチコード<br>在庫検索</b></v-tab>
          <v-tab to="/opt_custom_order" style="font-size: 0.6em"><b>光パッチコード<br>カスタムオーダー</b></v-tab>
          <v-tab to="/adapter" style="font-size: 0.6em"><b>光アダプタ</b></v-tab>
          <v-tab to="/opt_connector" style="font-size: 0.6em"><b>光コネクタ</b></v-tab>
          <v-tab to="/accessories" style="font-size: 0.6em"><b>アクセサリ</b></v-tab>
          <v-tab to="/component"><b>精密切削加工</b></v-tab>
        </v-tabs>
        </template>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        temporary
      >
        <v-list
          nav
          density="compact"
        >
          <template v-for="navList in navLists" :key="navList.name">
            <v-list-item
              v-if="!navList.lists"
              :to="navList.link"
              @click="menuClose"
            >
              <template v-slot:prepend>
                <v-icon>{{ navList.icon }}</v-icon>
              </template>
              <v-list-item-title>
                {{ navList.name }}
              </v-list-item-title>
            </v-list-item>
            <v-list-group
              v-else
              v-model="navList.active"
            >
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props">
                  <template v-slot:prepend>
                    <v-icon>{{ navList.icon }}</v-icon>
                  </template>
                  <v-list-item-title>
                    {{ navList.name }}
                  </v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-for="list in navList.lists"
                :key="list.name"
                :to="list.link"
              >
                <v-list-item-title>
                  {{ list.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list>
      </v-navigation-drawer>
    </header>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer
      app
    >
      <v-card
        flat
        tile
        width="100%"
        class="text-center"
        style="background-color: #707070"
      >
        <v-card-text class="text-white">
          <v-btn to="/privacy" class="text-white" variant="text">プライバシーポリシー</v-btn> |&nbsp;&nbsp;&nbsp;{{ new Date().getFullYear() }} <strong>(c) Tokyo Adcom Corporation. All Rights Reserved. </strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'

const route = useRoute()
const drawer = ref(false)

// 上部メニューのルートリスト
const topMenuRoutes = [
  '/president_greeting',
  '/staff_voice',
  '/business',
  '/company',
  '/toiawase',
  '/accessmap'
]

// 現在のルートが上部メニューに属するかどうか
const isTopMenuActive = computed(() => {
  return topMenuRoutes.includes(route.path)
})

const navLists = ref([
  {
    name: 'ホーム',
    icon: 'mdi-home',
    link: '/',
    active: false
  },
  {
    name: '新着情報',
    icon: 'mdi-newspaper-variant',
    link: '/news',
    active: false
  },
  {
    name: '電子部品',
    icon: 'mdi-chip',
    active: false,
    lists: [
      {
        name: '電子部品',
        link: '/electronics'
      },
      {
        name: '注目の電子部品',
        link: '/electronics_focus'
      },
      {
        name: '部品在庫検索',
        link: '/search'
      },
      {
        name: '取引メーカー',
        link: '/maker'
      }
    ]
  },
  {
    name: '光通信関連部品',
    icon: 'mdi-cable-data',
    active: false,
    lists: [
      {
        name: '在庫一覧',
        link: '/opt_stock'
      },
      {
        name: '光アッテネータ',
        link: '/attenuator'
      },
      {
        name: '光パッチコード在庫検索',
        link: '/opt_search'
      },
      {
        name: '光パッチコードカスタムオーダー',
        link: '/opt_custom_order'
      },
      {
        name: '光アダプタ',
        link: '/adapter'
      },
      {
        name: '光コネクタ',
        link: '/opt_connector'
      },
      {
        name: 'アクセサリ',
        link: '/accessories'
      }
    ]
  },
  {
    name: '精密切削加工',
    icon: 'mdi-screwdriver',
    link: '/component',
    active: false
  },
  {
    name: '代表ご挨拶',
    icon: 'mdi-account-tie',
    link: '/president_greeting',
    active: false
  },
  {
    name: 'スタッフの声',
    icon: 'mdi-account-multiple',
    link: '/staff_voice',
    active: false
  },
  {
    name: 'お問い合わせ',
    icon: 'mdi-phone',
    link: '/toiawase',
    active: false
  },
  {
    name: 'アクセスマップ',
    icon: 'mdi-map-marker',
    link: '/accessmap',
    active: false
  }
])

const createTitleDesc = (routeInstance: any) => {
  const baseTitle = '株式会社東京アドコム - 電子部品関連、光通信関連部品、精密度加工部品'
  const baseDesc = '私たち東京アドコムは電子部品関連、光通信関連部品、精密度加工部品を中心に、その他新製品や終息品などの入手困難品も独自のルートからお探しいたします。是非、御社のビジネスパートナーとして御利用ください。'
  
  const title = routeInstance.meta.title 
    ? `${routeInstance.meta.title} | ${baseTitle}`
    : baseTitle
    
  const description = routeInstance.meta.desc
    ? `${routeInstance.meta.desc}${baseDesc}`
    : baseDesc

  useHead({
    title,
    meta: [
      { name: 'description', content: description }
    ]
  })
}

const menuClose = () => {
  navLists.value.forEach((navList) => (navList.active = false))
}

onMounted(() => {
  createTitleDesc(route)
})

watch(route, (newRoute) => {
  createTitleDesc(newRoute)
})
</script>

<style lang="scss">
* :not(.v-icon) {
  font-family: "Hiragino Kaku Gothic Pro","メイリオ", sans-serif!important;
}

.custom-tabs {
  .v-tab {
    color: #616161 !important; // デフォルトはグレー (grey-darken-2)

    &.v-tab--selected {
      color: #1565C0 !important; // 選択時は青色 (blue-darken-3)
    }
  }

  // アクティブでないタブグループ
  &.inactive-tabs {
    .v-tab {
      &.v-tab--selected {
        color: #616161 !important; // 選択状態でもグレーのまま
      }
    }
  }
}
</style>